// extracted by mini-css-extract-plugin
export default {"heading":"aw-z","corrected":"bw-z","redirectVerbiageContainer":"cw-z","redirectVerbiageText":"dw-z"};